// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
// import { AttributeValueModel } from "@insite/client-framework/Types/ApiModels"; // Foundation
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import { attributesProps } from "@store/Themes/common/props/attributes";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

// Foundation --->
import useParentProductState from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useParentProductState";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { AttributeTypeModel, AttributeValueModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// <--- Foundation

interface OwnProps {
    maximumNumberAttributeTypes: number;
    extendedStyles?: ProductAttributesStyles;
    // Starter Custom Code
    overridedStyles?: ProductAttributesStyles;
    // Foundation
    selectedAttributesTypes?: AttributeTypeModel[];
    fallbackOnNormalAttributeType: boolean;
}

type Props = OwnProps & HasProduct;

export interface ProductAttributesStyles {
    container?: GridContainerProps;
    attributeTypeGridItem?: GridItemProps;
    attributeValueGridItem?: GridItemProps;
    attributeTypeText?: TypographyPresentationProps;
    attributeValueText?: TypographyPresentationProps;
    // Foundation
    wrapper?: InjectableCss;
    attributeWrapper?: InjectableCss;
}

export const productAttributesStyles: ProductAttributesStyles = {
    // Foundation --->
    container: {
        gap: 0,
    },
    attributeTypeGridItem: {
        width: [6, 6, 6, 4, 4],
        css: css`
            overflow: hidden;
        `,
    },
    attributeValueGridItem: {
        width: [6, 6, 6, 8, 8],
        css: css`
            overflow: hidden;
        `,
    },
    attributeTypeText: {
        css: css`
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smaller};
                font-weight: ${theme.design.typography.weight.base};
                `}
        `,
    },
    attributeValueText: {
        color: "text.dark",
        css: css`
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smaller};
                font-weight: ${theme.design.typography.weight.bold};
                `}
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    attributeWrapper: {
        css: css`
            ${contentSpacingStyles(0, 0, ".75em")}
        `,
    },
    // <--- Foundation
};

const ProductAttributes: FC<Props> = ({
    product: { attributeTypes },
    maximumNumberAttributeTypes,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
    // Foundation
    selectedAttributesTypes,
    fallbackOnNormalAttributeType,
}) => {
    const styles = useExpandProps(productAttributesStyles, extendedStyles, overridedStyles); // Starter Custom Code

    // Starter --->
    const parentProductState = useParentProductState();

    if (!parentProductState?.attributeTypes || parentProductState?.attributeTypes.length === 0) {
        return null;
    }
    // Starter Code

    const maximum = Math.min(maximumNumberAttributeTypes, 100);
    /* Foundation Custom Code - Start */
    const limitedAttributeTypes = (
        selectedAttributesTypes?.length ||
        (fallbackOnNormalAttributeType !== undefined && !fallbackOnNormalAttributeType)
            ? selectedAttributesTypes
            : parentProductState?.attributeTypes
    )?.slice(0, maximum);
    /* Foundation Custom Code - End */

    const displayAttributeValues = (attributeValues: AttributeValueModel[] | null) => {
        return (
            <Typography {...styles.attributeValueText}>
                {(attributeValues ?? []).map(a => a.valueDisplay).join(", ")}
            </Typography>
        );
    };

    return (
        // Foundation --->
        <>
            {limitedAttributeTypes?.length && limitedAttributeTypes?.length > 0 && (
                <StyledWrapper {...styles.wrapper}>
                    {limitedAttributeTypes?.map(attributeType => (
                        <React.Fragment key={attributeType.id.toString()}>
                            <StyledWrapper {...styles.attributeWrapper}>
                                <Typography
                                    {...styles.attributeTypeText}
                                    data-test-selector={`attributeType${attributeType.id}`}
                                >
                                    {`${attributeType.label || attributeType.name}: `}
                                </Typography>
                                <Typography
                                    {...styles.attributeValueText}
                                    data-test-selector={`attributeValuesFor${attributeType.id}`}
                                >
                                    {displayAttributeValues(attributeType.attributeValues) /* Starter Custom Code */}
                                </Typography>
                            </StyledWrapper>
                            {/* Starter Removed - attributeValueGridItem */}
                        </React.Fragment>
                    ))}
                </StyledWrapper>
            )}
        </>
        // <--- Foundation
    );
};

export default withProduct(ProductAttributes);
